// PRD 06 §2.1 — tab buttons switching between the module-card list (default)
// and the weekly calendar. Slice 5 wires the tab buttons + state; the
// per-tab content lands in Slice 6 (frequency) and Slice 9 (calendar).

import { useTranslation } from 'react-i18next';

export type DeploymentTab = 'FREQUENCY' | 'CALENDAR';

interface DeploymentTabsProps {
  activeTab: DeploymentTab;
  onChange: (tab: DeploymentTab) => void;
}

export function DeploymentTabs({ activeTab, onChange }: DeploymentTabsProps) {
  const { t } = useTranslation('pro-deployment');
  return (
    <div
      style={{
        display: 'flex',
        gap: 'var(--space-2)',
        marginBottom: 'var(--space-6)',
        borderBottom: '1px solid var(--border)',
        paddingBottom: 'var(--space-3)',
      }}
      role="tablist"
    >
      <TabButton
        label={t('tabs.byFrequency')}
        active={activeTab === 'FREQUENCY'}
        onClick={() => onChange('FREQUENCY')}
      />
      <TabButton
        label={t('tabs.byCalendar')}
        active={activeTab === 'CALENDAR'}
        onClick={() => onChange('CALENDAR')}
      />
    </div>
  );
}

interface TabButtonProps {
  label: string;
  active: boolean;
  onClick: () => void;
}

function TabButton({ label, active, onClick }: TabButtonProps) {
  return (
    <button
      type="button"
      role="tab"
      aria-selected={active}
      className={`btn btn-default ${active ? 'btn-primary' : 'btn-secondary'}`}
      style={{ borderRadius: 'var(--radius-sm) var(--radius-sm) 0 0' }}
      onClick={onClick}
    >
      {label}
    </button>
  );
}
